import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { ApiService } from './api.service';
import { CacheService } from './cache.service';
import { Course } from './course.model';

@Injectable({
    providedIn: 'root',
})
export class CourseService implements OnDestroy, OnInit {
    private courseUpdate = new Subject<any>();
    courseUpdate$ = this.courseUpdate.asObservable();

    // private formDataUpdate = new Subject<any>();
    // formDataUpdate$ = this.formDataUpdate.asObservable();

    private formDataUpdateRegion = new Subject<any>();
    formDataUpdateRegion$ = this.formDataUpdateRegion.asObservable();

    private formDataUpdateBudgetDiscipline = new Subject<any>();
    formDataUpdateBudgetDiscipline$ = this.formDataUpdateBudgetDiscipline.asObservable();

    private courseSave = new Subject<any>();
    courseSave$ = this.courseSave.asObservable();

    private courseEdit = new Subject<any>();
    courseEdit$ = this.courseEdit.asObservable();

    private courseReset = new Subject<any>();
    courseReset$ = this.courseReset.asObservable();

    // id: number;
    course: Course;
    isValid: boolean = false;
    isLoading: boolean = true;
    isLoaded: boolean = false;
    loadingError: boolean = false;
    errorMessage: string = '';
    display: boolean = false;
    isEditable: boolean = false;
    isDeleting: boolean = false;
    isSaving: boolean = false;
    submitted: boolean = false;
    formData = null;

    constructor(
        private apiService: ApiService,
        private cacheService: CacheService,
        private router: Router,
        private location: Location,
    ) {}

    ngOnInit(){
        this.isEditable = this.router.url.endsWith('/add') || this.router.url.endsWith('/edit');
    }
   
    // not firing via lifecycle; but triggering manually in detail.component.ts
    ngOnDestroy() {
        console.log(`clean up course service`)
        this.isValid = false;
        this.isLoading = true;
        this.isLoaded = false;
        this.loadingError = false;
        this.errorMessage = '';
        this.display = false;
        this.isEditable = false;
        this.isDeleting = false;
        this.isSaving = false;
        this.submitted = false;
        this.formData = null;
    }

    get(): void {
        if (!this.course.id) {
            this.course = new Course({});
            this.isLoading = false;
            this.formData = this.course;
            this.isLoaded = true;
            this.courseUpdate.next();
            return;
        }
        this.isLoading = true;
        this.loadingError = false;
        this.errorMessage = '';

        this.apiService.getCourse(this.course).subscribe(
            (data) => {
                this.course = new Course(data);
                this.formData = this.course;
                this.isLoading = false;
                this.isSaving = false;
                this.isLoaded = true;
                this.courseUpdate.next();
            },
            (error) => {
                this.loadingError = true;
                this.errorMessage = error;
                this.isLoading = false;
            }
        );
    }

    save() {
        this.submitted = true;
        if (!this.isValid || this.isSaving) return;
        this.isSaving = true;
        this.errorMessage = ``;

        if (this.course.id) {
            this.apiService
                .updateCourse(this.course, this.formData)
                .subscribe(
                    (data) => {
                        this.location.replaceState(`/admin/courses-and-events/${this.course.id}`);
                        this.isLoaded = false;
                        this.isEditable = false;
                        this.isSaving = false;
                        this.get();
                    },
                    (error) => {
                        this.loadingError = true;
                        this.errorMessage = error;
                        this.isSaving = false;
                    }
                );
            return;
        }

        this.apiService.createCourse(this.formData).subscribe(
            (data) => {
                // this.router.navigateByUrl(`/admin/courses-and-events/${data.course_id}`);
                this.location.replaceState(`/admin/courses-and-events/${this.course.id}`);
                this.isLoaded = false;
                this.isEditable = false;
                this.isSaving = false;
                this.course = new Course({id: data.course_id});
                this.get();
            },
            (error) => {
                this.errorMessage = error;
                this.isSaving = false;
            }
        );
    }

    delete() {
        // this.isDeleting = true;
        // this.apiService.deteleEvaluation(this.id).subscribe(
        //     (data) => {
        //         this.router.navigateByUrl(`/admin/courses-and-events`);
        //     },
        //     (error) => {
        //         this.errorMessage = error;
        //     }
        // );
    }

    updateFormData(value) {
        this.formData = value;
    }

    updateRegion(value) {
        this.formDataUpdateRegion.next(value);
    }

    updateBudgetDiscipline(value) {
        this.formDataUpdateBudgetDiscipline.next(value);
    }

    add() {
        this.course = new Course({});
        this.courseEdit.next();
        this.isEditable = true;
        this.display = true;
    }

    edit() {
        this.courseEdit.next();
        this.isEditable = true;
        this.display = true;
    }

    reset() {
        this.errorMessage = "";
        this.isEditable = false;
        this.courseReset.next();
    }
}
